import { ApolloClient, ApolloLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'
import { setContext } from '@apollo/client/link/context'
import { createConsumer } from '@rails/actioncable'
import ActionCableLink from 'graphql-ruby-client/subscriptions/ActionCableLink'

import AppState from 'shared/app_state'

const cable =
  window.location.hostname == 'powcloud.com' ? createConsumer('https://ws.powcloud.com/cable') : createConsumer()

const hasSubscriptionOperation = ({ query: { definitions } }) => {
  return definitions.some(({ kind, operation }) => kind === 'OperationDefinition' && operation === 'subscription')
}

const authLink = setContext((_, { headers }) => {
  // include current account in headers if it exists

  const currentAccount = AppState.getCurrentAccount()

  return {
    headers: {
      ...headers,
      ...(currentAccount && currentAccount.id ? { account: currentAccount.id } : {}),
    },
  }
})

const uploadLink = createUploadLink({
  uri: `/api/v1/dash`,
})

const link = ApolloLink.split(
  hasSubscriptionOperation,
  new ActionCableLink({ cable, channelName: 'GraphQLChannel' }),
  authLink.concat(uploadLink)
)

const apolloClient: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  cache: new InMemoryCache(),
  link,
})

export default apolloClient
